"use client";
import ImageRight from "@/components/ContentBlock/variants/ImageRight";
import { MonarchDataConsumer } from "@/monarch/MonarchDataConsumer";
import MonarchResolver from "@/monarch/MonarchResolver";
import type { DegreeDetailV4TestResult } from "@/monarch/rules/degreeDetailV4/types";
import type { BaseDegreeImageRightProps } from "./types";
import DegreeImageRightWrapper from "./DegreeImageRightWrapper";

export default function DegreeImageRight({
  children,
  section,
  uuid,
}: BaseDegreeImageRightProps) {
  const className = `[&_img]:rounded-xl ${section === "about" ? "!py-0" : "[&_ul]:px-2"}`;
  const useContainer = section === "admissions";
  return (
    <MonarchResolver<DegreeDetailV4TestResult>
      experimentKey="useDegreeDetailV4"
      variants={{
        control: (
          <DegreeImageRightWrapper
            className={className}
            section={section}
            useContainer={useContainer}
            uuid={uuid}
          >
            {children}
          </DegreeImageRightWrapper>
        ),
        test: (
          <MonarchDataConsumer<DegreeDetailV4TestResult>
            experimentKey="useDegreeDetailV4"
            render={(testResult) => {
              const { data } = testResult;
              const image =
                section === "about" ? data?.aboutImage : data?.admissionsImage;

              return (
                <ImageRight
                  imageurl={image?.url ?? ""}
                  imagetitle={image?.altText ?? ""}
                  height={image?.height}
                  width={image?.width}
                  className={className}
                  accentColor={data?.brandColor}
                  useContainer={useContainer}
                  responsiveImage={!!image}
                  reverseVertical={false}
                >
                  {children}
                </ImageRight>
              );
            }}
          />
        ),
      }}
      fallbackVariant="control"
    />
  );
}
